"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 接口消息模块
var _default = exports.default = {
  getMessageList: function getMessageList(data) {
    return (0, _request.default)({
      url: '/protected/message/list',
      method: 'post',
      data: data
    });
  },
  getMessageDetail: function getMessageDetail(appMessagePk) {
    return (0, _request.default)({
      url: '/protected/message/query/' + appMessagePk,
      method: 'post'
    });
  },
  saveMessage: function saveMessage(data) {
    return (0, _request.default)({
      url: '/protected/message/save',
      method: 'post',
      data: data
    });
  },
  deleteMessage: function deleteMessage(appMessagePk) {
    return (0, _request.default)({
      url: '/protected/message/delete/' + appMessagePk,
      method: 'post'
    });
  }
};